'use client';

import { tabsTriggerVariants } from '@paypoteam/page-components/Tabs';
import Link from 'next/link';

import {
    getShareholdersArchivePath,
    getShareholdersTabPath,
} from '@/services/shareholders/utils';

import type { ShareholdersMeetingTabsProps } from '../ShareholdersSection.types';

import { SHAREHOLDERS_SECTION_CONTENT } from '@/static/content/pl/shareholders';

const { meeting: LABELS } = SHAREHOLDERS_SECTION_CONTENT;

const TABS = [
    {
        key: 'upcoming',
        label: LABELS.upcomingTab,
        href: getShareholdersTabPath('walne-zgromadzenia'),
    },
    {
        key: 'archive',
        label: LABELS.archiveTab,
        href: getShareholdersArchivePath(),
    },
];

export default function ShareholdersMeetingTabs({
    label,
    active,
    'data-test-id': dataTestId,
}: ShareholdersMeetingTabsProps) {
    return (
        <nav aria-label={label}>
            <ul className="flex flex-wrap gap-2">
                {TABS.map(({ key, label: tabLabel, href }) => {
                    const isActive = key === active;

                    return (
                        <li key={key}>
                            <Link
                                href={href}
                                aria-current={isActive ? 'page' : undefined}
                                data-state={isActive ? 'active' : 'inactive'}
                                className={tabsTriggerVariants({
                                    variant: 'secondary',
                                    size: 'm',
                                })}
                                data-test-id={
                                    dataTestId && `${dataTestId}-subtab-${key}`
                                }
                            >
                                {tabLabel}
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}
